import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styles.css';

import Screenshot01 from '../../../assets/img/screenshots/01.png';
import Screenshot02 from '../../../assets/img/screenshots/02.png';
import Screenshot03 from '../../../assets/img/screenshots/03.png';
import Screenshot04 from '../../../assets/img/screenshots/04.png';
import Screenshot05 from '../../../assets/img/screenshots/05.png';

const NextArrow = ({ className, style, onClick }) =>{
  return (
    <div
      className={className}
      style={{ ...style, display: "block"}}
      onClick={onClick}
    />
  );
}

const PrevArrow = ({ className, style, onClick }) =>{
  return (
    <div
      className={className}
      style={{ ...style, display: "block"}}
      onClick={onClick}
    />
  );
}

const Screenshots = () =>{

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    autoplay: true,
    slidesToScroll: 2,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      }
    ]
  };
  return(
    <div
    className="container-fluid division3"
    id="screenshots">
      <h1 className="text-center title-responsive">
        simple and intuitive interface
      </h1>
      <div className="container division2">
        <Slider
        {...settings}>
          <img
          src={Screenshot01}
          alt=""
          className="p-2"
          />
          <img
          src={Screenshot02}
          alt=""
          className="p-2"
          />
          <img
          src={Screenshot03}
          alt=""
          className="p-2"
          />
          <img
          src={Screenshot04}
          alt=""
          className="p-2"
          />
          <img
          src={Screenshot05}
          alt=""
          className="p-2"
          />
        </Slider>
      </div>
    </div>  
  );
};
export default Screenshots